// What a QC check is about (mig 20261185000000): a production run, or a
// delivery checked at intake (qc_runs.source_delivery_id), or one pallet of
// that delivery (qc_runs.source_delivery_pallet_id, mig 20261296000000; it
// carries source_delivery_id too). One label rule for every surface that names
// a delivery check: the runner header, the record, Needs attention, the
// delivery's own card.

export interface QcDeliveryRef {
  grower:                string | null
  delivery_note_number?: string | null
  client_ref_no?:        string | null
}

/** "Delivery · {grower} · DN {n}" (else the grower's own reference). */
export function deliveryCheckLabel(d: QcDeliveryRef | null | undefined): string | null {
  if (!d) return null
  const dn = d.delivery_note_number?.trim()
  const ref = d.client_ref_no?.trim()
  return ['Delivery', d.grower?.trim() || '—', dn ? `DN ${dn}` : ref || null].filter(Boolean).join(' · ')
}

/** One pallet of a delivery, as a check names it: "Pallet 2 of 3". */
export interface QcPalletRef {
  pallet_id: string
  pallet_no: number
  /** How many pallets the delivery has; null when not known. */
  of:        number | null
}

export function palletCheckLabel(p: { pallet_no: number; of?: number | null }): string {
  return p.of ? `Pallet ${p.pallet_no} of ${p.of}` : `Pallet ${p.pallet_no}`
}

/** The subject the capture screen saves a check against. A run, or a delivery
 *  (then palletId may name one of its pallets). */
export interface QcSubject {
  runId:      string | null
  deliveryId: string | null
  /** A check on one pallet of the delivery (mig 20261296000000). */
  palletId:   string | null
  /** As a person reads it: the run number, or deliveryCheckLabel. */
  label:      string
  variety:    string | null
  /** Commodity NAME (size chart lookup); null when not known. */
  commodity:  string | null
}

export function runQcSubject(run: { run_id: string; run_number: string; variety: string | null; commodity?: string | null }): QcSubject {
  return { runId: run.run_id, deliveryId: null, palletId: null, label: run.run_number, variety: run.variety, commodity: run.commodity ?? null }
}

export function deliveryQcSubject(
  d: QcDeliveryRef & { delivery_id: string; variety: string | null },
  commodity: string | null = null,
  pallet: QcPalletRef | null = null,
): QcSubject {
  const label = deliveryCheckLabel(d) ?? 'Delivery'
  return {
    runId: null, deliveryId: d.delivery_id, palletId: pallet?.pallet_id ?? null,
    label: pallet ? `${label} · ${palletCheckLabel(pallet)}` : label,
    variety: d.variety, commodity,
  }
}
